export default __webpack_public_path__ + "static/media/meritz_img01.50a3d13a.png";